import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import cryptLib from '@skavinvarnan/cryptlib';
import _get from 'lodash/get';
import getImageUrl from '../../helpers/image-url';

const Column = ({
  column, id, record, schema,
}) => {
  if (column.link) {
    return (
      <td>
        <Link to={`${schema}/${record[id]}`}>{_get(record, column.id)}</Link>
      </td>
    );
  }
  if (column.decrypt) return <DecryptedColumn record={record} column={column} />;
  if (column.image) return <ImageColumn record={record} column={column} />;
  if (column.boolean) return <td>{_get(record, column.id, '').toString()}</td>;
  if (column.id.includes('.')) return <td>{_get(record, column.id, '').toString()}</td>;
  return <td>{record[column.id]}</td>;
};
Column.propTypes = {
  column: PropTypes.shape({}).isRequired,
  id: PropTypes.string.isRequired,
  schema: PropTypes.string.isRequired,
  record: PropTypes.shape({}).isRequired,
};

const DecryptedColumn = ({ column, record }) => {
  const decryptedString = cryptLib.decryptCipherTextWithRandomIV(
    record[column.id],
    'hello_secret_key',
  );
  return (
    <td>
      <a target="_blank" rel="noopener noreferrer" href={decryptedString}>
        {decryptedString}
      </a>
    </td>
  );
};
DecryptedColumn.propTypes = {
  column: PropTypes.shape({}).isRequired,
  record: PropTypes.shape({}).isRequired,
};

const ImageColumn = ({ column, record }) => {
  if (Array.isArray(column.id)) {
    const [first, last] = column.id;
    return (
      <td>
        <img src={`${getImageUrl(record[first])}${getImageUrl(record[last])}`} alt="record" width="30" />
      </td>
    );
  }
  return (
    <td>
      <img src={getImageUrl(_get(record, column.id))} alt="record" width="30" />
    </td>
  );
};
ImageColumn.propTypes = {
  column: PropTypes.shape({}).isRequired,
  record: PropTypes.shape({}).isRequired,
};

const List = ({
  columns, data, resource, schema,
}) => {
  const { id } = columns.find(column => column.link && column.label === 'ID');
  return data.map(item => (
    <tr key={item[id]}>
      {columns.map(column => (
        <Column
          key={Array.isArray(column.id) ? column.id.join('.') : column.id}
          resource={resource}
          record={item}
          id={id}
          column={column}
          schema={schema}
        />
      ))}
    </tr>
  ));
};

List.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  resource: PropTypes.string.isRequired,
  schema: PropTypes.string.isRequired,
};

export default List;
